export const hasPermission = (
  permissions,
  wrapperName,
  featureName
) => {
  const requiredPermissions = permissions;
  const result = { read: false, write: false, update: false, delete: false };
  if (!requiredPermissions) return result;

  const wrapper = requiredPermissions.find((t) => t.name === wrapperName);
  if (!wrapper) return result;

  const feature = wrapper.extendedFeatures.find((f) => f.name === featureName);

  if (!feature) return result;

  return feature.permissions;
};
